import React from "react";
import radium from "radium";
import CategoryLabel from "backpack-ui/dist/components/categoryLabel";
import Button from "backpack-ui/dist/components/button";
import { Heading } from "backpack-ui/dist/components/text";
import colors from "backpack-ui/dist/styles/colors";
import { Link } from "react-scroll";

const styles = {
  container: {
    width: "145%",
    marginTop: "32px",
  },
  label: {
    color: colors.accentRed,
  },
  innerList: {
    marginTop: "16px",
    marginBottom: "16px",
  },
};

const SCROLL_SPEED = 500;

const focusInputAfterScroll = () => {
  const insuranceInput = document.getElementById("destination-autocomplete");

  if (insuranceInput) {
    setTimeout(() => {
      insuranceInput.focus();
    }, SCROLL_SPEED + 100);
  }
};

const WorldNomadSidebarCallout = () => (
  <li key="insturance-side-bar">
    <div style={styles.container}>
      <CategoryLabel style={styles.label}>
        Important tip
      </CategoryLabel>

      <Heading
        level={6}
        size={6}
        weight="medium"
      >
        Travel insurance. Make sure you’re ready for anything
      </Heading>

      <ul
        className="inner-list"
        style={styles.innerList}
      >
        <li> - Trip cancellation</li>
        <li> - Emergency medical transportation</li>
        <li> - Emergency medical expenses</li>
        <li> - Gear lost or stolen</li>
      </ul>

      <Link
        duration={SCROLL_SPEED}
        isDynamic
        offset={-50}
        smooth
        to="worldNomadsWidget"
      >
        <Button
          rounded
          size="small"
          onClick={focusInputAfterScroll}
        >
          Get a price
        </Button>
      </Link>
    </div>
  </li>
);

export default radium(WorldNomadSidebarCallout);



// WEBPACK FOOTER //
// ./assets/pois/components/worldNomadsWidget/worldNomadSidebarCallout.jsx